import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const correlativeIdCol = (gantt, t) => {
  const name = 'correlative_id';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label: t('gantt.columns.id', 'ID'),
    align: 'center',
    width: '45',
    resize: true,
    hide: !isVisible,
    template: (activity) => {
      const isOdd = gantt.oddColsConfig?.correlative_id || false;
      const label = gantt.getTaskNumber(activity);
      return `
          <div class="${isOdd ? 'odd-col' : 'non-odd-col'}">
              ${label}
          </div>
          `;
    },
    data_type: 'number',
    groupable: false,
    orderable: true,
    orderable_switch: ['1 → 9', '9 → 1'],
    filterable: true,
  };
};

export default correlativeIdCol; 